import { Box3, Vector3 } from "three";
import type { PlanarGraphController } from "../../../shape/segment/PlanarGraphController";
import type { XzPoint } from "../../../shape/segment/types";
import type { SegmentSpec } from "../../../shape/segment/types";
import { segmentInteriorLogicalEdgeIndex } from "../../../shape/segment/segmentInteriorEdge";

export interface SegmentWallCollisionShape {
  segmentId: string;
  spec: SegmentSpec;
  interiorSide: 1 | -1;
  footprint: readonly XzPoint[];
  bounds: Box3;
  minY: number;
  maxY: number;
}

export class PlanarGraphWallCollisionProvider {
  constructor(
    private readonly _segments: PlanarGraphController,
    private readonly _wallHeight = 2.7,
  ) {}

  shapes(): SegmentWallCollisionShape[] {
    return this._segments.planarGraph.segments
      .filter((entry) => !entry.spec.placement)
      .map((entry) => {
        const footprint = entry.outline.corners;
        const bounds = new Box3();
        for (const point of footprint) {
          bounds.expandByPoint(new Vector3(point.x, 0, point.z));
          bounds.expandByPoint(new Vector3(point.x, this._wallHeight, point.z));
        }
        return {
          segmentId: entry.spec.id,
          spec: entry.spec,
          interiorSide:
            segmentInteriorLogicalEdgeIndex(
              this._segments.planarGraph,
              entry.spec.id,
            ) === 1
              ? 1
              : -1,
          footprint,
          bounds,
          minY: 0,
          maxY: this._wallHeight,
        };
      });
  }

  candidates(bounds: Box3, excludeSegmentId?: string): SegmentWallCollisionShape[] {
    return this.shapes().filter(
      (shape) =>
        shape.segmentId !== excludeSegmentId &&
        shape.bounds.intersectsBox(bounds),
    );
  }
}
